import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import TemplateList from "template-store/components/template-list/template-list";
import Banner from "template-store/components/banner/banner";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getBannerDescriptionKeyForCategory, getBannerTitleKeyForCategory } from "template-store/services/solution-categories-service";
import MobileTemplatesNavigation from "template-store/components/mobile-navigation/mobile-navigation-component";
import { StyledCategoryPageContent } from "./category-page-content.scss";
const CategoryPageContent = (props)=>{
    const { solutions, categoryData, translate, allCategories } = props;
    const bannerTitle = useMemo(()=>{
        return translate(getBannerTitleKeyForCategory(categoryData === null || categoryData === void 0 ? void 0 : categoryData.value));
    }, [
        categoryData
    ]);
    const bannerDescription = useMemo(()=>{
        return translate(getBannerDescriptionKeyForCategory(categoryData === null || categoryData === void 0 ? void 0 : categoryData.value));
    }, [
        categoryData
    ]);
    return /*#__PURE__*/ _jsxs(StyledCategoryPageContent, {
        className: "category-page-content-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "banner-wrapper",
                children: /*#__PURE__*/ _jsx(Banner, {
                    title: bannerTitle,
                    description: bannerDescription,
                    titleTagComponent: "h1",
                    descriptionTagComponent: "h3"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mobile-navigation-wrapper",
                children: /*#__PURE__*/ _jsx(MobileTemplatesNavigation, {
                    allCategories: allCategories,
                    selectedCategoryId: categoryData === null || categoryData === void 0 ? void 0 : categoryData.value
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-list-wrapper",
                children: /*#__PURE__*/ _jsx(TemplateList, {
                    solutions: solutions,
                    context: categoryData === null || categoryData === void 0 ? void 0 : categoryData.value
                })
            })
        ]
    });
};
export default withGenericConfig(CategoryPageContent);
